import { Box, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { ArticleForm, IArticleFormValues } from "../../forms";
import {
  ArticlesDocument,
  useArticleQuery,
  useUpdateArticleMutation,
} from "../../graphql";

const ArticleEditPage: React.FC = () => {
  const toast = useToast();
  const [update] = useUpdateArticleMutation();
  const { id } = useParams<{ id: string }>();
  const articleId = parseInt(id);

  const { data, loading } = useArticleQuery({
    variables: {
      id: articleId,
    },
  });

  const onUpdate = async (values: IArticleFormValues) => {
    const { data } = await update({
      variables: {
        id: articleId,
        coverMediaKey: values.cover.key,
        body: values.body,
        title: values.title,
        languageCode: values.languageCode,
        excerpt: values.excerpt,
      },
      refetchQueries: [{ query: ArticlesDocument }],
    });

    toast({
      description: "Artikulli u ndryshua.",
      status: "success",
      isClosable: true,
    });
  };

  return (
    <>
      <Box
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        p={2}
        background="white"
      >
        <Title title={`Duke redaktuar: ${data?.article?.title || ""}`}></Title>

        {loading ? (
          <Loader />
        ) : (
          <ArticleForm
            onSubmit={onUpdate}
            initialValues={{
              body: data.article.body,
              title: data.article.title,
              excerpt: data.article.excerpt,
              cover: {
                url: data.article.cover.url,
                key: data.article.cover.key,
              },
              languageCode: data.article.language.code,
            }}
          />
        )}
      </Box>
    </>
  );
};

export default ArticleEditPage;
